<div *ngIf="displaySubscriberInfo || subscriberInfo.manifestDate || subscriberInfo.manifestExpirationDate" class="aside-wrapper gray-100">
  <span class="user-card text-blue-five icon-user-card d-sm-none d-md-block"></span>
  <dl class="ml-2 text-break">
    <dt *ngIf="displaySubscriberInfo">
      {{'SubscriberInformation.SubscriberNumber' | translate}}
    </dt>
    <dd *ngIf="displaySubscriberInfo">
      {{subscriberInfo.subscriberNumber}}
    </dd>

    <dt *ngIf="displaySubscriberInfo">
      {{'SubscriberInformation.Name' | translate}}
    </dt>
    <dd *ngIf="displaySubscriberInfo">
      {{subscriberInfo.name}}
    </dd>

    <dt *ngIf="displaySubscriberInfo && workflowCode!='PEDI002'">
      {{'SubscriberInformation.DateOfBirth' | translate}}
    </dt>
    <dd *ngIf="displaySubscriberInfo && !isMaskOn && workflowCode!='PEDI002'">
      {{subscriberInfo.dateOfBirth | date : 'yyyy-MM-dd'}}
    </dd>
    <dd *ngIf="displaySubscriberInfo && isMaskOn  && workflowCode!='PEDI002'">
      {{getMaskDate(subscriberInfo.dateOfBirth)}}
    </dd>

    <dt *ngIf="displaySubscriberInfo && workflowCode!='PEDI002'">
      {{'SubscriberInformation.FiscalNumber' | translate}}
    </dt>
    <dt *ngIf="displaySubscriberInfo && workflowCode=='PEDI002'">
      {{'SubscriberInformation.FiscalNumberDeceased' | translate}}
    </dt>
    <dd *ngIf="displaySubscriberInfo">
      {{subscriberInfo.fiscalNumber}}
    </dd>


    <!-- PIT39680 - Start -->
    <dt *ngIf="displaySubscriberInfo && allowSharedData">
      {{'SubscriberInformation.MobileNumber' | translate}}
    </dt>
    <dd *ngIf="displaySubscriberInfo && allowSharedData">
      {{subscriberInfo.mobileNumber}}
    </dd>

    <dt *ngIf="displaySubscriberInfo && allowSharedData">
      {{'SubscriberInformation.Email' | translate}}
    </dt>
    <dd *ngIf="displaySubscriberInfo && allowSharedData">
      {{subscriberInfo.email}}
    </dd>
    <!-- PIT39680 - End -->


    <dt *ngIf="subscriberInfo.manifestDate" [style.display]="workflowCode?.indexOf('PEDI0020')>-1?'none':'block'">
      {{'SubscriberInformation.ManifestDate' | translate}}
    </dt>
    <dd *ngIf="subscriberInfo.manifestDate" [style.display]="workflowCode?.indexOf('PEDI0020')>-1?'none':'block'">
      {{subscriberInfo.manifestDate | date : 'yyyy-MM-dd'}}
    </dd>
    <dt *ngIf="subscriberInfo.manifestAcceptDate" [style.display]="workflowCode?.indexOf('PEDI0020')>-1?'none':'block'">
      {{'SubscriberInformation.ManifestAcceptDate' | translate}}
    </dt>
    <dd *ngIf="subscriberInfo.manifestAcceptDate" [style.display]="workflowCode?.indexOf('PEDI0020')>-1?'none':'block'">
      {{subscriberInfo.manifestAcceptDate | date : 'yyyy-MM-dd'}}
    </dd>
    <dt *ngIf="subscriberInfo.manifestExpirationDate">
      {{'SubscriberInformation.ManifestExpirationDate' | translate}}
    </dt>
    <dd *ngIf="subscriberInfo.manifestExpirationDate">
      {{subscriberInfo.manifestExpirationDate | date : 'yyyy-MM-dd'}}
    </dd>
    <dt *ngIf="subscriberInfo.sendToRevisionDate">
      {{'SubscriberInformation.SendToRevisionDate' | translate}}
    </dt>
    <dd *ngIf="subscriberInfo.sendToRevisionDate">
      {{subscriberInfo.sendToRevisionDate | date : 'yyyy-MM-dd'}}
    </dd>
  </dl>
</div>
